import { Spacing, Theme } from '../types';

const isSpacingKey = (theme: Theme, value: unknown): value is keyof Spacing =>
  (value as string) in theme.core.spacing;

export default isSpacingKey;
